/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionAuthSupportsRequestUpdate } from '../../models/subscription-auth-supports-request-update';

export interface UpdateSubscriptionAuthSupportsRequest$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The object ID. Must be a valid ID.
 */
  authSupportUid: string;
  
    /**
     * The auth supports request update object
     */
    body: SubscriptionAuthSupportsRequestUpdate
}

export function updateSubscriptionAuthSupportsRequest(http: HttpClient, rootUrl: string, params: UpdateSubscriptionAuthSupportsRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateSubscriptionAuthSupportsRequest.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('authSupportUid', params.authSupportUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateSubscriptionAuthSupportsRequest.PATH = '/custom/subscriptions/{uid}/auth-supports-requests/{authSupportUid}';
